// Country → region / currency / supported-languages map.
// Mirrors the CMS `localization/locales` document that this used to fetch.

const COUNTRIES = [
  { name: { en: 'Ukraine' }, region: 'Europe', currency: 'UAH', language: ['ua'] },
  { name: { en: 'Moldova' }, region: 'Europe', currency: 'MDL', language: ['ro'] },
  { name: { en: 'Romania' }, region: 'Europe', currency: 'RON', language: ['ro'] },
  { name: { en: 'United Kingdom' }, region: 'Europe', currency: 'GBP', language: ['en'] },
  { name: { en: 'Germany' }, region: 'Europe', currency: 'EUR', language: ['de'] },
  { name: { en: 'France' }, region: 'Europe', currency: 'EUR', language: ['fr'] },
  { name: { en: 'Italy' }, region: 'Europe', currency: 'EUR', language: ['it'] },
  { name: { en: 'Spain' }, region: 'Europe', currency: 'EUR', language: ['es', 'ca'] },
  { name: { en: 'Portugal' }, region: 'Europe', currency: 'EUR', language: ['pt'] },
  { name: { en: 'Poland' }, region: 'Europe', currency: 'PLN', language: ['pl'] },
  { name: { en: 'Czech Republic' }, region: 'Europe', currency: 'CZK', language: ['cs'] },
  { name: { en: 'Slovakia' }, region: 'Europe', currency: 'EUR', language: ['sk'] },
  { name: { en: 'Hungary' }, region: 'Europe', currency: 'HUF', language: ['hu'] },
  { name: { en: 'Bulgaria' }, region: 'Europe', currency: 'BGN', language: ['bg'] },
  { name: { en: 'Finland' }, region: 'Europe', currency: 'EUR', language: ['fi'] },
  { name: { en: 'Sweden' }, region: 'Europe', currency: 'SEK', language: ['sv'] },
  { name: { en: 'Denmark' }, region: 'Europe', currency: 'DKK', language: ['da'] },
  { name: { en: 'Norway' }, region: 'Europe', currency: 'NOK', language: ['no'] },
  { name: { en: 'Iceland' }, region: 'Europe', currency: 'ISK', language: ['is'] },
  { name: { en: 'Lithuania' }, region: 'Europe', currency: 'EUR', language: ['lt'] },
  { name: { en: 'Latvia' }, region: 'Europe', currency: 'EUR', language: ['lv'] },
  { name: { en: 'Estonia' }, region: 'Europe', currency: 'EUR', language: ['et'] },
  { name: { en: 'Serbia' }, region: 'Europe', currency: 'RSD', language: ['sr'] },
  { name: { en: 'Croatia' }, region: 'Europe', currency: 'EUR', language: ['hr'] },
  { name: { en: 'North Macedonia' }, region: 'Europe', currency: 'MKD', language: ['mk'] },
  { name: { en: 'Albania' }, region: 'Europe', currency: 'ALL', language: ['sq'] },
  { name: { en: 'Slovenia' }, region: 'Europe', currency: 'EUR', language: ['sl'] },
  { name: { en: 'Greece' }, region: 'Europe', currency: 'EUR', language: ['el'] },
  { name: { en: 'Turkey' }, region: 'Asia', currency: 'TRY', language: ['tr'] },
  { name: { en: 'Netherlands' }, region: 'Europe', currency: 'EUR', language: ['nl'] },
  { name: { en: 'Georgia' }, region: 'Asia', currency: 'GEL', language: ['ka'] },
  { name: { en: 'Armenia' }, region: 'Asia', currency: 'AMD', language: ['hy'] },
  { name: { en: 'United States' }, region: 'North America', currency: 'USD', language: ['en'] },
  { name: { en: 'Canada' }, region: 'North America', currency: 'CAD', language: ['en', 'fr'] },
  { name: { en: 'Australia' }, region: 'Oceania', currency: 'AUD', language: ['en'] },
  { name: { en: 'New Zealand' }, region: 'Oceania', currency: 'NZD', language: ['en'] },
  { name: { en: 'Ireland' }, region: 'Europe', currency: 'EUR', language: ['en'] },
  { name: { en: 'South Africa' }, region: 'Africa', currency: 'ZAR', language: ['en'] },
  { name: { en: 'Brazil' }, region: 'South America', currency: 'BRL', language: ['pt'] },
  { name: { en: 'Mexico' }, region: 'North America', currency: 'MXN', language: ['es'] },
  { name: { en: 'Argentina' }, region: 'South America', currency: 'ARS', language: ['es'] },
  { name: { en: 'Colombia' }, region: 'South America', currency: 'COP', language: ['es'] },
  { name: { en: 'Chile' }, region: 'South America', currency: 'CLP', language: ['es'] },
  { name: { en: 'Peru' }, region: 'South America', currency: 'PEN', language: ['es'] },
  { name: { en: 'Venezuela' }, region: 'South America', currency: 'VES', language: ['es'] },
  { name: { en: 'Ecuador' }, region: 'South America', currency: 'USD', language: ['es'] },
  { name: { en: 'Guatemala' }, region: 'North America', currency: 'GTQ', language: ['es'] },
  { name: { en: 'Cuba' }, region: 'North America', currency: 'CUP', language: ['es'] },
  { name: { en: 'Dominican Republic' }, region: 'North America', currency: 'DOP', language: ['es'] },
  { name: { en: 'Bolivia' }, region: 'South America', currency: 'BOB', language: ['es'] },
  { name: { en: 'Honduras' }, region: 'North America', currency: 'HNL', language: ['es'] },
  { name: { en: 'Paraguay' }, region: 'South America', currency: 'PYG', language: ['es'] },
  { name: { en: 'El Salvador' }, region: 'North America', currency: 'USD', language: ['es'] },
  { name: { en: 'Nicaragua' }, region: 'North America', currency: 'NIO', language: ['es'] },
  { name: { en: 'Costa Rica' }, region: 'North America', currency: 'CRC', language: ['es'] },
  { name: { en: 'Panama' }, region: 'North America', currency: 'PAB', language: ['es'] },
  { name: { en: 'Uruguay' }, region: 'South America', currency: 'UYU', language: ['es'] },
  { name: { en: 'Belgium' }, region: 'Europe', currency: 'EUR', language: ['nl', 'fr', 'de'] },
  { name: { en: 'Switzerland' }, region: 'Europe', currency: 'CHF', language: ['de', 'fr', 'it'] },
  { name: { en: 'Austria' }, region: 'Europe', currency: 'EUR', language: ['de'] },
  { name: { en: 'Luxembourg' }, region: 'Europe', currency: 'EUR', language: ['fr', 'de'] },
  { name: { en: 'Monaco' }, region: 'Europe', currency: 'EUR', language: ['fr'] },
  { name: { en: 'Andorra' }, region: 'Europe', currency: 'EUR', language: ['ca'] },
  { name: { en: 'Cyprus' }, region: 'Europe', currency: 'EUR', language: ['el', 'tr'] },
  { name: { en: 'Malta' }, region: 'Europe', currency: 'EUR', language: ['en'] },
];

export { COUNTRIES };
